"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.groupItems = exports.formatSearchCategories = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _flat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flat"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _filter = _interopRequireDefault(require("lodash/filter"));
/**
 * Combines search categories array and results items array
 * into one array ordered by category
 *
 * @param {{category: String, display: String}[]} categories
 * @param {{content_type: String, value: String, label: String}[]} items
 * @returns {{string: String}[]}
 */

const groupItems = (categories, items) => {
  if (!items) return [];
  if (!categories || !(0, _isArray.default)(categories) || !categories.length || typeof categories[0] === 'string') return items;
  const groupedArrays = (0, _map.default)(categories).call(categories, cat => {
    var _context;
    const itemsInCategory = (0, _filter.default)(items, ['content_type', cat.category]);
    if (itemsInCategory?.length) return (0, _concat.default)(_context = [cat]).call(_context, itemsInCategory);
    return [];
  });
  return (0, _flat.default)(groupedArrays).call(groupedArrays);
};

/**
 * Turns search_categories array (from customer service via @kyruus/patient-case)
 * into string consumable by typeahead endpoint
 *
 * @param {{category: String, display: String}[]} categories
 * @returns {String} Example: '-ALL,+clinical_experience,+practice_group,+name'
 */
exports.groupItems = groupItems;
const formatSearchCategories = categories => {
  if (typeof categories === 'string') return categories;
  if (!(0, _isArray.default)(categories) || categories.length === 0) return '';
  return (0, _reduce.default)(categories).call(categories, (acc, curr) => `${acc},+${curr.category}`, '-ALL');
};
exports.formatSearchCategories = formatSearchCategories;